<div class="tab-contents" data-contents>
    <div class="wpdh-tab-block__result">
        <ng-content></ng-content>
    </div>
</div>